$(document).ready(function () {


   
  
  

  


  $( ".mega-menu" ).hover(
    function() {
      console.log("menu---")
      $(this).attr("open", "opened");      
      
    }, function() {
      $(this).removeAttr("open");      
    }
  );

  $( ".mega-menu" ).click(function(event){
    event.preventDefault();

   
    
  });


  $(".mega-menu__link").click (function(event){
    var go_url = $(this).attr("href");
    console.log("go url", go_url);
     location.href = go_url;
    //$(this).trigger("click");
    
  })
  

    $('.features_slider').not('.slick-initialized').slick({
    
    slidesToShow: 2,
    centerMode: false,
    centerPadding: '60px',
    arrows: true,
    dots: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
 
  });


  if ($("#width_slider").length > 0 ) {

    var width_slider = document.getElementById('width_slider');

    noUiSlider.create(width_slider, {
        start: [0, 14],
        connect: true,
        direction: 'ltr',
        step: 1,
        behaviour: 'tap-drag',
        tooltips: true,      
        format: wNumb({
            decimals: 0,
            suffix: ''
        }),
        // Show a scale with the slider
         pips: {
            mode: 'values',
            values: [0, 2, 4, 6, 8, 10, 12, 14],
            density: 7
        },
        range: {
            'min': 0,
            'max': 14
        }
    });

   var length_slider = document.getElementById('length_slider');

    noUiSlider.create(length_slider, {
        start: [0, 14],
        connect: true,
        direction: 'ltr',
        step: 1,
        behaviour: 'tap-drag',
        tooltips: true,      
        format: wNumb({
            decimals: 0,
            suffix: ''
        }),
        // Show a scale with the slider
         pips: {
            mode: 'values',
            values: [0, 2, 4, 6, 8, 10, 12, 14],
            density: 7
        },
        range: {
            'min': 0,
            'max': 14
        }
    });
          

    
  }

    

  $(".collection_filter_content_filter_check").on("click", function(){

    /*
    $( ".collection_filter_content_filter_check" ).each(function( index ) {
      if ($(this).hasClass("active")){
        $(this).removeClass("active")
      }
    });
    */
    if($(this).hasClass("active") ){
      $(this).removeClass("active");  
    }else {
      $(this).addClass("active");  
    }
    

    
  })

  $(".collection_filter_content_bed_filter_check").on("click", function(){
    /*
     $( ".collection_filter_content_bed_filter_check" ).each(function( index ) {
      if ($(this).hasClass("active")){
        $(this).removeClass("active")
      }
    });
    */
    if($(this).hasClass("active") ){
      $(this).removeClass("active");
    }else {
      $(this).addClass("active");  
    }
    
    //$("#Filter-filter.p.m.custom.pick_your_garden_bed-2").prop("checked", true);
  })


  $(".collection_filter_apply_btn").on("click", function(){
    const bed_value = [];
    const like_value = [];
    
    $( ".collection_filter_content_bed_filter_check" ).each(function( index ) {
      if ($(this).hasClass("active")){
        bed_value_item =   $(this).attr('id');
        bed_value.push(bed_value_item)
      }
    });

    $( ".collection_filter_content_filter_check" ).each(function( index ) {
      if ($(this).hasClass("active")){
        like_value_item = $(this).attr('id');
        like_value.push(like_value_item)
      }
    });

    /*
    $("input[name='filter.p.m.custom.pick_your_garden_bed']").each(function(index){
       var current_id = $(this).attr('id');
      
      
      //$(this).prop("checked", false)        
        console.log("input id",current_id)
     
      
     
    })

    $("input[name='filter.p.m.custom.which_shape_would_you_like']").each(function(index){
       var current_id = $(this).attr('id');
      
      
      //$(this).prop("checked", false)        
        console.log("input id",current_id)
     
      
     
    })
    */


    var width_values;
    var width_low_value = 0;
    var width_high_value = 0;
    width_values = width_slider.noUiSlider.get();

    width_low_value = parseInt(width_values[0])
    width_high_value = parseInt(width_values[1])

    var length_values;
    var length_low_value = 0;
    var length_high_value = 0;
    length_values = length_slider.noUiSlider.get();

    length_low_value = parseInt(length_values[0])
    length_high_value = parseInt(length_values[1])

    console.log("log, high", length_low_value, length_high_value)
    

     $("input[name='filter.p.m.custom.width_length']").each(function(index){
        var filter_wl_value = $(this).attr("value");
       console.log("filter_wl_value", filter_wl_value)
       let filter_wl_w = parseInt(filter_wl_value.split("x")[0]);
       let filter_wl_l = parseInt(filter_wl_value.split("x")[1]);
       console.log("filter_wl_values", filter_wl_w, filter_wl_l)

       if (filter_wl_w >= width_low_value && filter_wl_w <= width_high_value)
       {

         if (filter_wl_l >= length_low_value && filter_wl_l <= length_high_value)
         {
           if ($(this).prop('checked')){
             
           }else{
             $(this).click();  
           }
           
         }else{
            if ($(this).prop('checked')){
              $(this).click();  
            }
                  
         }
       }else {
         if (filter_wl_l >= length_low_value && filter_wl_l <= length_high_value)
         {
           if ($(this).prop('checked')){
             $(this).click();  
           }else{
             
           }
           
         }else{
            if ($(this).prop('checked')){
              $(this).click();  
            }
                  
         }
          
       }
       
       
     })
    
    
 

    //Set bed filter


    $("input[name='filter.p.m.custom.pick_your_garden_bed']").each(function(index){

      console.log("input_val", $(this).attr("value"))
      if ($(this).prop('checked')){
              $(this).click();   
      }

      var current_value = $(this).attr("value");
      for(i=0;i<bed_value.length;i++){
        console.log("bed_value:",i, bed_value[i])
        if (bed_value[i] == "bed_11"){       
            if (current_value == "11\""){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
              
        }else if (bed_value[i] == "bed_16"){
          console.log("here")
          if (current_value == "16.5\""){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
       
        }else if(bed_value[i] == "bed_22") {
          console.log("here22")
           if (current_value == "22\""){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
        }else if(bed_value[i] == "bed_5") {
          if (current_value == "5.5\""){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
        }
      }
      
      
    })

    /*
    for(i=0;i<bed_value.length;i++){
      console.log("bed_value:",i, bed_value[i])
      if (bed_value[i] == "bed_11"){        
        $("input[name='filter.p.m.custom.pick_your_garden_bed']").val("11\"").click();
      }else if (bed_value[i] == "bed_16"){
        console.log("here")
        //$("#Filter-filter.p.m.custom.pick_your_garden_bed-2").prop("checked", true)
        $("input[name='filter.p.m.custom.pick_your_garden_bed']").val("16.5\"").click();    
     
      }else if(bed_value[i] == "bed_22") {
        console.log("here22")
        $("input[name='filter.p.m.custom.pick_your_garden_bed']").val("22\"").trigger("click");     
      }else if(bed_value[i] == "bed_5") {
        $("input[name='filter.p.m.custom.pick_your_garden_bed']").val("5.5\"").click();     
      }
    }
    */


    $("input[name='filter.p.m.custom.which_shape_would_you_like']").each(function(index){
      console.log("input_like_val", $(this).attr("value"))
      if ($(this).prop('checked')){
              $(this).click();   
      }

      var current_value = $(this).attr("value");
      for(i=0;i<like_value.length;i++){
        console.log("like_value:",i, like_value[i])
        if (like_value[i] == "like_rectangle"){       
            if (current_value == "Rectangular"){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
              
        }else if (like_value[i] == "like_curved"){
          console.log("here")
          if (current_value == "Curved"){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
       
        }else if(like_value[i] == "like_corner") {
          console.log("here22")
           if (current_value == "Corner"){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
        }else if(like_value[i] == "like_special") {
          if (current_value == "Special"){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
        }else if(like_value[i] == "like_tiered") {
          if (current_value == "Tiered"){
               if ($(this).prop('checked')){
                
              }else {
                $(this).click();   
              }
            }
        }
      }
      
    })


    //set like filter
    /*
    for(i=0;i<like_value.length;i++){
      console.log("like_value:",i, like_value[i])
     if (like_value[i] == "like_rectangle"){ 
        $("input[name='filter.p.m.custom.which_shape_would_you_like']").val("Rectangular").click();
        
      }else if (like_value[i] == "like_curved"){
         $("input[name='filter.p.m.custom.which_shape_would_you_like']").val("Curved").click();
     
      }else if(like_value[i] == "like_corner") {
       $("input[name='filter.p.m.custom.which_shape_would_you_like']").val("Corner").click();
      }else if(like_value[i] == "like_special") {
       $("input[name='filter.p.m.custom.which_shape_would_you_like']").val("Special").click();
      }else if(like_value[i] == "like_tiered") {
       $("input[name='filter.p.m.custom.which_shape_would_you_like']").val("Tiered").click();
      }
    }
    */
    
  })


  //reset button
  $(".collection_filter_reset_btn").on("click", function(){
    console.log("herwwwe");
    $( ".collection_filter_content_bed_filter_check" ).each(function( index ) {
      if ($(this).hasClass("active")){
        $(this).removeClass("active")
      }
    });

    $( ".collection_filter_content_filter_check" ).each(function( index ) {
      if ($(this).hasClass("active")){
        $(this).removeClass("active")
      }
    });

    width_slider.noUiSlider.set([0,14]);
    length_slider.noUiSlider.set([0,14]);
    $(".active-facets__button-remove")[0].click()
  })





let featuredProductSelect = document.querySelectorAll('[data-section-id="pf-7d2c"] .pf-variant-select');
let featuredProductRadio = document.querySelectorAll('[data-section-id="pf-7d2c"] .pf-vs-color input[type="radio"]');
let featuredProductAdd = document.querySelectorAll('[data-section-id="pf-7d2c"] [name="add"]');
let cartNotification = document.getElementById('cart-notification');
let cartNotificationButton = document.getElementById('cart-notification-button');
let cartNotificationProduct = document.getElementById('cart-notification-product');
let cartIcon = document.getElementById('cart-icon-bubble').querySelector('.cart-count-bubble span[aria-hidden="true"]');

featuredProductAdd.forEach( button => {
  button.addEventListener("click", ()=> {
    cartNotification.classList.add('animate','active');
    updateCartCount();
    updateImage(button);
  })
})


featuredProductRadio.forEach(select => {
  select.addEventListener("change", ()=> {
    updateImage(select);
  })
})  

featuredProductSelect.forEach(select => {
  select.addEventListener("change", ()=> {
    updateImage(select);
  })
})  
  
function updateCartCount() {

  setTimeout(() => {
    fetch("/cart.js")
    .then((resp) => resp.json())
    .then(
      (data) => {
        cartNotificationButton.innerText = `View cart (${data.item_count})`;
        cartIcon.innerText = `${data.item_count}`;
        console.log(data);
      }
    )    
    .catch((err) => console.log(err))
  }, 1500);

}

function updateImage(select) {
  
  let link = select.closest('form').querySelector("h3").getAttribute("data-href");
  
  fetch(`${link}.js`)
  .then((response) => response.json())
  .then((data) => {
    console.log(data);
    let variantId = select.closest('form').querySelector('[name="id"]').value;
    
    let productOptions = "";
    console.log(data.variants.length);

    if (data.variants.length > 1) {
    data.variants.forEach(function (variant) {
      
      if (variant.id == variantId) {
      
      select.closest('form').querySelector('img').setAttribute("src", variant.featured_image.src);
      select.closest('form').querySelector('img').setAttribute("srcset", variant.featured_image.src);
      
      data.options.forEach(function (option, index) {         
          productOptions += `<div class="product-option"><dt>${option.name}: </dt><dd></dd>${variant.options[index]}</div>`
       })
       
      cartNotificationProduct.innerHTML = 
      `<div class="cart-notification-product__image global-media-settings">
        <img src="${variant.featured_image.src}" width="70" height="40"/>
      </div>
      <div>
        <h3 class="cart-notification-product__name h4">${select.closest('form').querySelector("h3").innerText}</h3>
        <dl>${productOptions}</dl>
      </div>      
      `      
      }
    })
  } else {
     cartNotificationProduct.innerHTML = 
       `<div class="cart-notification-product__image global-media-settings">
        <img src="${data.featured_image}" width="70" height="40"/>
      </div>
      <div>
        <h3 class="cart-notification-product__name h4">${data.title}</h3>        
      </div> `
  }
  })
  .catch((error) => {
    // Handle errors
    console.error(error);
  });
}

});
